import React from "react";
import { X } from "lucide-react";
import { JOIN_LABEL, formatDate, tierLabel } from "./fusionApi";

/**
 * "Why are these connected?" (FUSION.md §9). Lists every link the arrow carries with the evidence the
 * existing match left behind. Fusion never matched anything itself, and says so.
 */
const FusionWhyPopover = ({ links, labelOf, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4" onClick={onClose}>
    <div role="dialog" aria-label="Why are these connected?" className="w-full max-w-3xl max-h-[85vh] overflow-auto rounded-xl border border-border bg-theme-secondary p-4 shadow-xl" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-semibold text-content-primary">Why are these connected?</h3>
        <button onClick={onClose} aria-label="Close" className="p-1 rounded hover:bg-theme-hover"><X className="h-4 w-4" /></button>
      </div>
      <p className="text-xs text-content-secondary mb-3">
        Every link below was made by an existing Axaris match. Fusion carries its confidence; it never matches anything itself.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left text-content-secondary border-b border-border">
              <th className="py-1.5 pr-2">From</th><th className="pr-2">To</th><th className="pr-2">Join</th><th className="pr-2">Confidence</th>
              <th className="pr-2">Matched on</th><th className="pr-2">Seen</th><th>Source</th>
            </tr>
          </thead>
          <tbody>
            {links.map((l, i) => (
              <tr key={i} className="border-b border-border align-top">
                <td className="py-1.5 pr-2 text-content-primary">{labelOf(l.sourceType, l.sourceId)}</td>
                <td className="pr-2 text-content-primary">{labelOf(l.targetType, l.targetId)}</td>
                <td className="pr-2">{JOIN_LABEL[l.joinType] || l.joinType}</td>
                <td className="pr-2">
                  <span className={`px-1.5 py-0.5 rounded font-semibold ${l.confidence === "confirmed" ? "bg-green-50 text-green-700" : "bg-amber-50 text-amber-700 border border-dashed border-amber-400"}`}>
                    {tierLabel(l.confidence)}
                  </span>
                </td>
                <td className="pr-2">{l.matchKind}{l.matchValue && <div className="text-content-muted break-all">{l.matchValue}</div>}</td>
                <td className="pr-2 whitespace-nowrap">{formatDate(l.firstSeenAt)} → {formatDate(l.lastSeenAt)}</td>
                <td>{l.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default FusionWhyPopover;
